import React from "react";
import { Link } from "react-router-dom";
import { HUB_FLOATING_RAIL_ITEMS } from "../../constants/hubFloatingRail";
import "../../assets/styles/hub_floating_rail.scss";

export default function HubFloatingRail() {
  return (
    <aside className="hub-floating-rail" aria-label="Customer services quick links">
      {HUB_FLOATING_RAIL_ITEMS.map((item) => {
        const Icon = item.icon;
        const className = [
          "hub-floating-rail__item",
          `hub-floating-rail__item--${item.tone}`,
          item.accent ? "hub-floating-rail__item--accent" : "",
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <Link key={item.key} to={item.href} className={className} aria-label={item.label} title={item.label}>
            <Icon aria-hidden />
          </Link>
        );
      })}
    </aside>
  );
}
